'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "actionLocation"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { VIEW_DASHBOARD_DETAILS } from 'dashboard-lib/public/action/reporting-action';
import { useShowDialog } from 'reporting-action-components/dialog/ducks';
import { EVENTS, track } from '../usage-tracking/track';
import { ActionLocationPropType } from '../usage-tracking/tracking-constants';
import { jsx as _jsx } from "react/jsx-runtime";
const DashboardDetailsAction = props => {
  const {
      children,
      actionLocation
    } = props,
    dialogProps = _objectWithoutPropertiesLoose(props, _excluded);
  const showDialog = useShowDialog();
  const openDashboardDetails = () => {
    track(EVENTS.clickViewAssetDetails, {
      actionType: 'edit',
      action: 'edit',
      assetType: 'dashboard',
      interactionSource: actionLocation,
      interactionWith: 'asset-action'
    });
    showDialog({
      dialogType: VIEW_DASHBOARD_DETAILS,
      dialogProps: Object.assign({
        actionLocation
      }, dialogProps)
    });
  };
  return /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: () => openDashboardDetails(),
    children: children || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboardDetails.name"
    })
  }, "dashboard-details");
};
DashboardDetailsAction.propTypes = {
  actionLocation: ActionLocationPropType,
  children: PropTypes.node
};
export default DashboardDetailsAction;